import { Paper, Popper as Popper, styled } from "@mui/material";

export const HelperTextPaper = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.info.main}`,
  padding: theme.spacing(0.5, 1.5),
  maxWidth: theme.spacing(43.125),
}));

export const HelperTextPopper = styled(Popper)(({ theme, placement }) => ({
  [`& > ${HelperTextPaper}`]: {
    // default placement is top-start
    margin:
      placement?.startsWith("left") || placement?.startsWith("right")
        ? theme.spacing(0.5, 0.25)
        : theme.spacing(0.25, 0),
  },
}));
